import { render, staticRenderFns } from "./WX.vue?vue&type=template&id=0161b79d&scoped=true&"
import script from "./WX.vue?vue&type=script&lang=js&"
export * from "./WX.vue?vue&type=script&lang=js&"
import style0 from "./WX.vue?vue&type=style&index=0&id=0161b79d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161b79d",
  null
  
)

export default component.exports